export default class TokenMalformedError extends Error {
  constructor(message: string) {
    super(message);
  }
}
